import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Onderneming } from '../models/Onderneming';
import { DataService } from '../services/data.service';
import { OndernemingService } from '../services/onderneming.service';


@Component({
  selector: 'app-sstools',
  templateUrl: './sstools.component.html',
  styleUrls: ['./sstools.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SstoolsComponent implements OnInit {
  ondernemingNaam: string;
  ondernemingId: string;
  isLoading = true;
  onderneming$: Observable<Onderneming>;
  shouldShowHeader$: Observable<boolean>;

  constructor(
    private route: ActivatedRoute,
    public r: Router,
    private ondernemingService: OndernemingService,
    public dataService: DataService,
  ) {
  }

  // Ophalen van de correcte onderneming.
  ngOnInit(): void {
    this.ondernemingNaam = this.route.snapshot.paramMap.get('ondernemingNaam');
    //this.ondernemingId = this.route.snapshot.paramMap.get('ondernemingId');
    localStorage.setItem('onderneming', JSON.stringify(this.ondernemingNaam));
    //localStorage.setItem('ondernemingId', JSON.stringify(this.ondernemingId));


    this.onderneming$ = this.ondernemingService.streamOndernemingNaam(this.ondernemingNaam).pipe(tap(() => {
      
      this.isLoading = false;
      if(!this.dataService.onderneming)
      {
       this.r.navigate(['/pagina-niet-gevonden']);
      }
    }));
    // Show header by default, unless the current route has a data property 'noHeader' set to true. See app-routing.module.ts.
    this.shouldShowHeader$ = this.route.data.pipe(map(routeData => !routeData.noHeader));
  }
}
